<ion-header>
    <ion-toolbar class="header-color">
            <ion-buttons slot="start">
                <ion-back-button defaultHref="search/promotions"></ion-back-button>
             </ion-buttons>
          <ion-title *ngIf="promotion?.class">{{isActivityExpired ? 'Activity Expired' : promotion?.class.title | titlecase }}</ion-title>
    </ion-toolbar>
    <app-promoga-alert></app-promoga-alert>
</ion-header>

<ion-content *ngIf="isActivityExpired">
    <div class="padding-top-50">
        <p class="text-center info-activity-expired">Activity Expired. Search for other activities <a
         routerLink="/search/promotions">here</a>.</p>
   </div>
</ion-content>
<ion-content *ngIf="!isActivityExpired">
    <div class="hero padding-extra text-center" *ngIf="promotion.class">
        <div class="card_details2__labels">
          <span>
              <label *ngIf="promotion.class.online_locations.length > 0 && !(promotion.class.medium && promotion.class.medium.length == 2)"
                    class="online-label">
                  online
              </label>
             <label class="online-label online-label&#45;&#45;hybrid"
             *ngIf="promotion.class.medium && promotion.class.medium.length == 2">
                 <span>hybrid</span>
             </label>
          </span>
        </div>
        <ion-button *ngIf="promotion.class.has_ace == 1" class="social_btn" (click)="presentAlert()">
            After Social
        </ion-button>
        <ion-img [src]="promotion| getImage:'cover' " class="bg"></ion-img>
    <div class="hero-content padding-horizontal">
        <div class="flexBox">
            <div class="user-info" *ngIf="promotion.class">
                <ion-avatar class="user_profile" (click)="showInstructor(promotion.class.instructor)">
                    <img [src]="promotion?.class.instructor | getImage:'profile' ">
                </ion-avatar>
                <span class="username bold" (click)="showInstructor(promotion.class.instructor)">{{promotion?.class.instructor.first_name}} {{promotion?.class.instructor.last_name}}</span>
            </div>
            <div class="user-location" *ngIf="promotion.class" (click)="showStudio(promotion)">
                <span class="yoga-title bold"> {{promotion?.class.venue.name|titlecase}}</span><br/>
                <p class="location">
                    <span class="orange_icon">
                        <ion-icon name="location-outline" ></ion-icon>
                    </span>
                    {{ promotion?.class.venue.city | titlecase  }}, {{ promotion?.class.venue.province_state.toUpperCase() }}
                </p>
          </div>
        </div>
    </div>
    </div>

<div class="padding-horizontal" *ngIf="promotion?.class">
    <div class="flexBox">
        <div class="info-time">
            <span class="session-venue">{{promotion?.class.title | titlecase }}</span>
            <p>
                <span class="session-time ">
                    {{ (promotion?.next_sessions[0] ? promotion?.next_sessions[0].startdate_timestamp : promotion?.classes.first_session) | date: 'MMM dd, yyyy'}} @
                    {{ promotion?.classes.first_session | date: 'h:mma'}}
                   <span *ngIf="promotion.class.online_locations.length <= 0">{{ timezoneService.getTimezoneCode(promotion.class.venue.time_zone) }}</span>
                   <span *ngIf="!(promotion.class.online_locations.length <= 0)">{{ userTimezone }}</span>
                    </span>
                <svg *ngIf="promotion.class.online_locations.length > 0" (click)="openTooltip($event)"
                     xmlns="http://www.w3.org/2000/svg" class="session-venue-svg h-5 w-5" viewBox="0 0 20 20"
                     fill="currentColor">
                    <path fill-rule="evenodd"
                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z"
                          clip-rule="evenodd"/>
                </svg>
            </p>
        </div>
        <div class="info-cost">
            {{ promotion?.session_value | sessionDisplay }}<br>
            <span class="strike-original-price discount-text">{{ promotion | retailPrice }}</span>
            <span class="bold energized total-amount-text">{{promotion | discountPrice }}</span><br>
            <span *ngIf="promotion.pricing_type_id == 2" class="discount-percent-text">Savings of <span class="energized">{{ promotion.percent_discount | number: '1.0-0' }}%</span></span>
        </div>
    </div>
    <div class="radio-info" *ngIf="promotion.class.medium && promotion.class.medium.length == 2">
        <div>
             <input type="radio" [disabled]="promotion.is_onsite_full" [(ngModel)]="selectedActivityType" value="onsite" id="switch_left" />
             <label for="switch_left" style="padding-left:7px; font-size: 14px;">Onsite</label>&nbsp;
             <label *ngIf="promotion.is_onsite_full" class="class-full-txt">(Onsite Sessions Full)</label>
        </div>
        <div style="margin-top: 10px;">
             <input type="radio" [disabled]="promotion.is_online_full" [(ngModel)]="selectedActivityType" value="online" id="switch_right" />
             <label for="switch_right" style="padding-left:7px; font-size: 14px;">Online</label>&nbsp;
             <label *ngIf="promotion.is_online_full" class="class-full-txt">(Online Sessions Full)</label>
        </div>
     </div>
    <hr />
</div>

<div class="alertSec padding-horizontal" *ngIf="promotion?.class">
    <h3>Activity Details</h3>
    <div class="alert alert-info">
        <div class="activity-detail">
            <div class="calendarIcon">
                <img src="assets/images/calendarIcon.png" width="37" height="42" />
            </div>
            <div class="activity-info" *ngIf="promotion?.class">
                <h4 class="calm bold text-uppercase">
                   {{getNextSessionTimestamp() | date:'MMM dd'}}
                  <span *ngIf="(getNextSessionTimestamp() | date:'MMM dd') != (getLastClassDate() | date:'MMM dd')">
                     - {{getLastClassDate() | date:'MMM dd'}}</span>
                </h4>
                <p *ngFor="let item of promotionSchedule">
                        <span>{{item['day'] | lowercase | titlecase }} </span>
                        <span *ngFor="let time of item['times']">
                                 {{time.starttime | ampmdate}} {{time.endtime | ampmdate}}
                                 <span *ngIf="promotion.class.online_locations.length <= 0">{{ timezoneService.getTimezoneCode(promotion.class.venue.time_zone) }}</span>
                                 <span *ngIf="!(promotion.class.online_locations.length <= 0)">{{ userTimezone }}</span>
                        </span>
                </p>
                <div class="stable">Activity Types: {{categories}}</div>
            </div>
        </div>
    </div>
    <hr />
</div>

<div class="details padding-horizontal" *ngIf="promotion?.class">
    <h3>Description</h3>
    <p>{{promotion?.class.description | slice:0:250 }}
        <span *ngIf="promotion && promotion.class.description.length > 250" class="show-more-btn" (click)="showDescription(promotion.class.description)">
            Show more..
        </span>
    </p>
    <h3>Share On</h3>
    <span class="social-icon-btns">
        <a (click)="shareFacebook()" target="_blank">
            <img src="assets/images/fb-icon.jpg" width="37" height="42" />
        </a>
        <a (click)="shareTwitter()" href="{{twitterShareUrl}}" target="_blank">
            <img src="assets/images/twitter-icon.jpg" width="37" height="42" />
        </a>
        <a (click)="shareEmail()" href="mailto:?subject=Check out this activity on Promoga: {{promotion?.class.title | titlecase}}&body={{emailBody}}" target="_blank">
            <img src="assets/images/email.png" width="38" height="38" />
        </a>
        <a (click)="copyUrlToClipboard()" target="_blank"  style="cursor: pointer;" title="Copy Link">
            <img src="assets/images/ic-share-url.png" width="40" height="38" />
        </a>
    </span>
    <hr />
</div>

<div class="directions padding-horizontal">
  <h3 *ngIf="promotion.terms">Venue Map</h3>
  <div id="map-view">
        <!-- <span>&nbsp;&nbsp;</span> -->
        <div #mapContainer id="map"></div>
    </div>
  <!-- <h5>{{promotion?.classes.venue.name|uppercase}}</h5> -->
  <p>
      <!-- {{promotion?.classes.venue.suite_apt}} <span *ngIf="promotion?.classes.venue.suite_apt"> - </span>{{promotion?.classes.venue.street_address}} -->
  <!-- <br>{{promotion?.classes.venue.city}}, {{promotion?.classes.venue.province_state}}, {{promotion?.classes.venue.postal_zip}} -->
  <!-- <br>{{promotion?.classes.venue.country | uppercase}} -->
  </p>
  <!-- TODO Add Directions functionality -->
  <!-- <ion-button *ngIf="promotion.terms" expand="block" fill="outline" class="directionBtn" (click)="getDirections()">Directions</ion-button> -->
  <hr *ngIf="promotion.terms"/>
</div>

<div class="terms padding-horizontal" *ngIf="promotion.terms">
  <h5>Terms</h5>
  <ul class="styled-list">
         <li *ngFor="let term of promotion.terms">{{term.terms_desc}}</li>
         <li *ngFor="let term of promotion.custom_terms | customTermsSplitter">{{ term }}</li>
  </ul>
</div>
</ion-content>

<ion-footer class="ion-no-border" *ngIf="!isActivityExpired">
    <ion-toolbar *ngIf="promotion?.class">
        <ion-button expand="full" class="joinnowBtn" (click)="purchasePromotion(promotion)">
            Join Now
        </ion-button>
    </ion-toolbar>
</ion-footer>
